exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "a.explore{display:block;width:211px;height:36px;padding-left:20px;background:#50d8f5;border:2px solid #50d8f5;line-height:36px;color:#fff;position:relative}a.explore:after{content:\">\";width:36px;height:36px;background:#fff;text-align:center;color:#50d8f5;position:absolute;top:0;right:0}.card.widget{height:340px;position:relative}.card.widget h3{width:280px;height:50px;padding:15px 20px;background:#fff;font-size:20px;line-height:25px;position:absolute;bottom:20px;left:20px}.card.widget h3 small{display:block;margin-top:5px;font-family:Avenir,Calibri,Helvetica,Arial,sans-serif;font-size:16px;font-weight:400;line-height:20px}.desc.widget li{padding-left:15px;position:relative}.desc.widget li:before{content:\"\";width:4px;height:4px;background:#50d8f5;position:absolute;top:10px;left:1px}@media screen and (max-width:850px){.card.widget,.card.widget img{width:236px}.card.widget h3{width:236px;left:-10px}}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/less-loader!./src/components/widgets/widgets.less
 ** module id = 159
 ** module chunks = 0
 **/